import api from "@/services/api";
import { decamelizeKeys } from "humps";

const { get, post } = api.getPrefixedMethods("templates");

export const templateService = {
  getTemplates({
    clientCompanyId,
    templateTypes,
    intakeOrderId,
    intakeDocumentKey,
    orderInfoKey,
    appealId,
    orderFormId,
    insuranceCardId,
    page,
  } = {}) {
    const params = {
      page,
      client_company_id: clientCompanyId,
      context_intake_order_id: intakeOrderId,
      context_intake_document_key: intakeDocumentKey,
      context_order_info_key: orderInfoKey,
      context_appeal_id: appealId,
      context_order_form_id: orderFormId,
      context_insurance_card_id: insuranceCardId,
    };

    // Only include template_types if the array is not empty
    if (templateTypes && templateTypes.length > 0) {
      params.template_types = templateTypes.join(",");
    }

    return get("", { params });
  },
  createAppealCoverSheet(data) {
    return post("appeal-cover-sheet/", data);
  },
  getFaxContent(requestData) {
    // _skipPropsAdaptation keeps the HTML response raw but also skips request decamelization,
    // so decamelize here — the backend only reads snake_case keys (order_info_key, intake_order_id).
    return post(`fax-content/`, decamelizeKeys(requestData), {
      responseType: "text",
      _skipPropsAdaptation: true,
    });
  },
};
